import React,{useState,useEffect}from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateRight,faCode,faHeart,faXmark} from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { add, addfilter, remove } from './redux/actions';
import { store } from './redux/store';
export default function Rightnav(props) {
    const mysel=useSelector(state=>state.red1.favdata)
    const [cross,setcross]=useState(faCode)
    const [dos,setdos]=useState(false)
    const [repeat,setRepeat]=useState(true)
    const dispatch=useDispatch()
    const [dwgl,setDwgl]=useState(false)
    
    useEffect(()=>{
        if(dos===true){
            open()
        }
        else{
            close()
        }
    },[dos])
    const open=()=>{
        document.getElementById('codeid').style.display='block';
        document.getElementById('rmitems2').style.zIndex='1'
        document.getElementById('rmitems1').style.transform='translateX(55px)'
        document.getElementById('rmitems3').style.transform='translateX(-55px)'
        setTimeout(() => {
            document.getElementById('codeid').classList='code';
            document.getElementById('codeid').classList.add('codeExpand');
            setcross(faXmark)
        }, 500);

        setTimeout(() => {
            document.getElementById('shapeCode').classList='codeBox';
            document.getElementById('shapeCode').classList.add('codeBoxappear');
            document.getElementById('copybtn1').style.opacity='1'
        }, 1000);
        setTimeout(() => {
            document.getElementById('selCode').classList='codeBox';
            document.getElementById('selCode').classList.add('codeBoxappear');
            document.getElementById('copybtn2').style.opacity='1'
        }, 1100);
        setTimeout(() => {
            document.getElementById('kfrCode').classList='codeBox';
            document.getElementById('kfrCode').classList.add('codeBoxappear');
            document.getElementById('copybtn3').style.opacity='1'
        },1200);

    }
    var close=()=>{
        setTimeout(() => {
            document.getElementById('codeid').classList.add('codeShrink');
            setcross(faCode) 
        }, 300);
        document.getElementById('shapeCode').classList.add('codeBoxdisappear');
        document.getElementById('selCode').classList.add('codeBoxdisappear');
        document.getElementById('kfrCode').classList.add('codeBoxdisappear');
        document.getElementById('copybtn1').style.opacity='0'
        document.getElementById('copybtn2').style.opacity='0'
        document.getElementById('copybtn3').style.opacity='0'
        setTimeout(() => {
            document.getElementById('codeid').style.display='none';
            document.getElementById('rmitems2').style.zIndex='1'
            document.getElementById('rmitems1').style.transform='translateX(0px)'
            document.getElementById('rmitems3').style.transform='translateX(0px)'
        }, 600);

        

    }

    const favwork=()=>{
        dispatch(add(props.msg))
        const nextState = store.getState();
        if(mysel.includes(props.msg)){
            dispatch(remove(props.msg))
        }
        setDwgl(!dwgl)
        props.dwglu(dwgl)
          // console.log(store.getState().red1.favkfrs)
  // console.log(store.getState().red1.favdata)
        dispatch(addfilter(Object.fromEntries(
            Object.entries(store.getState().red1.favkfrs).filter(([key, value]) =>
            store.getState().red1.favdata.map(str => str.replace(/-/g, '_')).includes(key)
            )
          )))

    }
    
  return (
    <div className='rightnav flex-center' id='rightnavid'>
        <div className='rmicons flex-center' id='rmitems1' onClick={()=>{setRepeat(!repeat);props.rep(repeat)}}><FontAwesomeIcon icon={faRotateRight} /></div>
        <div className='rmicons flex-center' id='rmitems2' onClick={()=>setdos(!dos)}><FontAwesomeIcon icon={cross} /></div>
        <div className='rmicons flex-center ' id='rmitems3' onClick={()=>favwork()}><FontAwesomeIcon icon={faHeart} /></div>
      </div>

  )
}